// Rendering (React React-Router)
// using import because React uses ES2015 constructs

import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { connect } from 'react-redux';
import * as actions from './actions'; // action creaters are in ../actions/index.js by convention
// BrowserRouter: brains
// Route: routing rule

import Home from "./pages/Home/home";
import SignIn from "./pages/Signin/signin";
import Landing from "./pages/Landing/Landing";
import Explore from "./pages/Explore/Explore";
import StartTrial from "./pages/StartTrial/StartTrial";
import Terms from "./pages/Terms/Terms";
import Display from "./pages/Display/Display";
import Ops from "./pages/Ops/Ops";
import Header from "./components/header/Header";
import Autolog from "./components/autolog/Autolog";

import "./App.css"

// App chrome (auto-login widget + nav) shown on the caregiver-facing routes.
// The kiosk /display route is rendered bare for full-screen kiosk use.
const WithChrome = ({ children }) => (
    <div>
        <Autolog />
        <Header />
        {children}
    </div>
);

class App extends React.Component  {

    componentDidMount(){
        this.props.listenForAuth();
    }

    render(){
        return (
            <BrowserRouter>
                <Routes>
                    {/* Resident kiosk (bare, full-screen). /resident is a friendly alias for /display. */}
                    <Route path='/display' element={<Display />} />
                    <Route path='/resident' element={<Display />} />
                    {/* Public marketing landing + self-serve trial signup (bare). */}
                    <Route path='/' element={<Landing />} />
                    <Route path='/explore' element={<Explore />} />
                    <Route path='/start' element={<StartTrial />} />
                    <Route path='/terms' element={<Terms />} />
                    {/* Sign in for existing members (full-screen, its own layout). */}
                    <Route path='/signin' element={<SignIn />} />
                    {/* Caregiver management board. /caregiver is a friendly alias for /home. */}
                    <Route path='/home' element={<WithChrome><Home /></WithChrome>} />
                    <Route path='/caregiver' element={<WithChrome><Home /></WithChrome>} />
                    {/* Internal ops usage dashboard (super-admin only; bare, no chrome). */}
                    <Route path='/ops' element={<Ops />} />
                </Routes>
            </BrowserRouter>
        );
    }
};

// connect connects actions to props in this case.   Normally, we pass
//  a mapDispatchToProps function that returns functions that have been passed
//  dispatch.  Please see ../actions/index.js for how this is implemented without
//  mapDispatchToProps.
 
// connect(state, actions)

const mapStateToProps = state => ({
    auth : state.auth
})
export default connect(mapStateToProps, actions)(App);
